import CookieContainer from "./CookieContainer";
var CookiePolicyType;
(function (CookiePolicyType) {
    CookiePolicyType[CookiePolicyType["None"] = 0] = "None";
    CookiePolicyType[CookiePolicyType["All"] = 1] = "All";
    CookiePolicyType[CookiePolicyType["OnlyNecessary"] = 2] = "OnlyNecessary";
})(CookiePolicyType || (CookiePolicyType = {}));
/**
 * The cookie policy consent cookie
 * - If it does not exists, then user has to be prompted for their consent.
 * - If it is given then it is either All for accepting all cookies OR
 *    OnlyNecessary for accepting only the necessary (for the operation of the site) cookies.
 * */
var ConsentCookie = /** @class */ (function () {
    function ConsentCookie() {
    }
    ConsentCookie.isGiven = function () {
        return this.isAll() || this.isNecessaryOnly();
    };
    ConsentCookie.isAll = function () {
        return this.currentPolicy() == CookiePolicyType.All;
    };
    ConsentCookie.isNecessaryOnly = function () {
        return this.currentPolicy() == CookiePolicyType.OnlyNecessary;
    };
    ConsentCookie.currentPolicy = function () {
        var consentValue = CookieContainer.get('_mconsent');
        if (consentValue) {
            return Number(consentValue);
        }
        else {
            return CookiePolicyType.None;
        }
    };
    ConsentCookie.setAll = function (expiryDays, domain, path) {
        CookieContainer.set('_mconsent', CookiePolicyType.All, expiryDays, domain, path, null, null);
    };
    ConsentCookie.setNecessaryOnly = function (expiryDays, domain, path) {
        CookieContainer.set('_mconsent', CookiePolicyType.OnlyNecessary, expiryDays, domain, path, null, null);
    };
    return ConsentCookie;
}());
export default ConsentCookie;
